import { Observable } from 'rxjs/observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
var cleaner = require('clean-html');

@Injectable()
export class DataService {

	private Code: BehaviorSubject<string> = new BehaviorSubject('');
	actionBarEnabled: BehaviorSubject<Boolean> = new BehaviorSubject(false);
	headerToolsEnabled: BehaviorSubject<Boolean> = new BehaviorSubject(true);
	copyToClipboardText: BehaviorSubject<boolean> = new BehaviorSubject(false);
	actionBarRightList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
	actionBarLeftList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
	headerToolsList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
	// public showCode : BehaviorSubject<Boolean> = new BehaviorSubject(true);
	// public toggle = this.showCode.asObservable();
	public showCode: BehaviorSubject<any> = new BehaviorSubject<any>('');
	// public toggleVal = false;
	// public showCode : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


	constructor() {

	}

	public GetCode(): Observable<string> {
		return this.Code.asObservable();
	}

	// showCode(){
	//    this.toggleVal = !this.toggleVal;
	//    this.toggleState.next(this.toggleVal);
	// }

	public SetCode(value: string) {
		var options = {
			'indent': '    ',
			'remove-comments': true,
			'remove-tags': [/app-/],
			'remove-attributes': [/ng-/, /routerlink/],
			'break-around-tags': ['body', 'blockquote', 'br', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'hr', 'link', 'meta', 'p', 'table', 'title', 'td', 'tr', 'i', 'a', 'button', 'ul', 'div', 'form', 'span']
		};
		cleaner.clean(value, options, function (html) {
			value = html;
		});
		this.Code.next(value);
	}

	setState(name) {
		this.showCode.next(name);
	}

	getState(): Observable<any> {
		return this.showCode.asObservable();
	}

	Copy(data) {
		let selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = data;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.copyToClipboardText.next(true);
		setTimeout(() => {
			this.copyToClipboardText.next(false);
		}, 3000);
	}

	public SetCodeAndReturn(value: string): string {
		var options = {
			'indent': '    ',
			'remove-comments': true,
			'remove-tags': [/app-/],
			'remove-attributes': [/ng-/, /routerlink/],
			'break-around-tags': ['body', 'blockquote', 'br', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'hr', 'link', 'meta', 'p', 'table', 'title', 'td', 'tr', 'i', 'a', 'button', 'ul', 'div', 'form', 'span']
		};
		cleaner.clean(value, options, function (html) {
			value = html;
		});
		return value;
	}

	public SetActionBarRightList(list: any) {
		this.actionBarRightList.next(list);
	}

	public SetActionBarLeftList(list: any) {
		this.actionBarLeftList.next(list);
	}

	public SetHeaderToolsList(list: any) {
		this.headerToolsList.next(list);
	}

	public toggleActionBar(value: Boolean) {
		this.actionBarEnabled.next(value);
	}
	public toggleHeaderTools(value: Boolean) {
		this.headerToolsEnabled.next(value);
	}

}


// WEBPACK FOOTER //
// ./src/Services/DataSharingService.ts